import { getLookupPage, getLookupRecord, readField } from '../api';

const validNumericId = id => Number.isSafeInteger(Number(id)) && Number(id) > 0;
const validGuid = id => typeof id === 'string'
    && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)
    && id !== '00000000-0000-0000-0000-000000000000';
const findStates = async (ids, signal) => {
    const names = new Map();
    if (!ids.size) return names;
    for (let pageIndex = 0; !signal?.aborted; pageIndex += 1) {
        const { items, total } = await getLookupPage('operational-states', { pageIndex, pageSize: 25, sortBy: 'Name', sortDirection: 'asc' }, signal);
        items.forEach(item => {
            const id = String(readField(item, 'id'));
            if (ids.has(id)) names.set(id, readField(item, 'name'));
        });
        if ([...ids].every(id => names.has(id)) || !items.length || (pageIndex + 1) * 25 >= total) break;
    }
    return names;
};

export const resolveLicensingReferences = async (rows, signal) => {
    const stateIds = new Set(rows.filter(row => !row.stateName && validNumericId(row.stateId)).map(row => String(row.stateId)));
    const requests = new Map();
    if (stateIds.size) requests.set('states', findStates(stateIds, signal));
    rows.forEach(row => {
        for (const [entity, id, needed] of [['commodities', row.commodityId, true], ['license-types', row.licenseTypeId, !row.licenseTypeName]]) {
            const key = `${entity}:${id}`;
            if (needed && validGuid(id) && !requests.has(key)) requests.set(key, getLookupRecord(entity, id, signal));
        }
    });
    const results = await Promise.allSettled(requests.values());
    const records = new Map();
    [...requests.keys()].forEach((key, index) => {
        if (results[index].status === 'fulfilled') records.set(key, results[index].value);
    });
    return {
        failed: results.some(result => result.status === 'rejected'),
        rows: rows.map(row => {
            const commodity = records.get(`commodities:${row.commodityId}`);
            return {
                ...row,
                stateName: row.stateName || records.get('states')?.get(String(row.stateId)),
                licenseTypeName: row.licenseTypeName || readField(records.get(`license-types:${row.licenseTypeId}`), 'name'),
                commodity: commodity && Object.fromEntries(['name', 'abbreviation', 'commodityIcon', 'commodityColor'].map(key => [key, readField(commodity, key)])),
            };
        }),
    };
};
